import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import bannerEn from '../../assets/images/ACCESSIBLE_PIERIA_BANNER_EN.png';
import bannerGr from '../../assets/images/ACCESSIBLE_PIERIA_BANNER_GR.png';

const Title = styled.div`
  font-size: 40px;
  display: flex;
  color: #385963;
  font-weight: 600;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 25px;
    margin-bottom: 20px;
    place-self: center;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 20px;
    place-self: center;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 200px;

  @media (max-width: 768px) {
    margin-bottom: 80px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;     /* keeps aspect ratio */
    display: block;
  }
`;

const ButtonDesktop = styled.button`
  position: absolute;
  right: 32px;
  bottom: 32px;

  background: #385963;
  color: white;
  font-weight: 600;
  padding: 14px 28px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: background 0.2s ease;
  min-width: 200px;
  height: 80px;

  &:hover {
    background: #91abb3;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const ButtonMobile = styled.button`
  margin: 20px auto 0;
  display: none;

  background: #385963;
  color: white;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  width: 160px;
  height: 60px;
  transition: background 0.2s ease;

  &:hover {
    background: #91abb3;
  }

  @media (max-width: 768px) {
    display: block;
    font-size: 12px;
  }
`;

export default function AccessibilityHomeModal({ setAccessibilityOpen }) {
  const { i18n } = useTranslation();

  const bgImage = i18n.language === "en" ? bannerEn : bannerGr;

  return (
    <>
      <Title data-aos="zoom-in-down">
        {i18n.t('accessibilityPoints')}
      </Title>

      <Wrapper>
        <ImageContainer>
          <img src={bgImage} alt="accessible pieria banner" />

          <ButtonDesktop onClick={() => setAccessibilityOpen(true)}>
            {i18n.t('discoverMore')}
          </ButtonDesktop>
        </ImageContainer>

        <ButtonMobile onClick={() => setAccessibilityOpen(true)}>
          {i18n.t('discoverMore')}
        </ButtonMobile>
      </Wrapper>
    </>
  );
}
